var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAtencion = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.2976 13.5L10.2976 3.00004C10.1668 2.76919 9.97702 2.57718 9.74776 2.44359C9.5185 2.31 9.25791 2.23962 8.99257 2.23962C8.72723 2.23962 8.46664 2.31 8.23738 2.44359C8.00812 2.57718 7.8184 2.76919 7.68757 3.00004L1.68757 13.5C1.55533 13.729 1.48599 13.9889 1.48658 14.2534C1.48716 14.5178 1.55765 14.7774 1.6909 15.0059C1.82416 15.2343 2.01543 15.4234 2.24534 15.5541C2.47525 15.6848 2.73563 15.7524 3.00007 15.75H15.0001C15.2633 15.7497 15.5217 15.6802 15.7496 15.5485C15.9774 15.4167 16.1665 15.2273 16.298 14.9993C16.4295 14.7714 16.4986 14.5128 16.4986 14.2496C16.4985 13.9864 16.4292 13.7279 16.2976 13.5Z",
  stroke: "#F59E0B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 6.75V9.75",
  stroke: "#F59E0B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 12.75H9.0075",
  stroke: "#F59E0B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAtencion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/atencion.cd4d50b7.svg";
export { ForwardRef as ReactComponent };